<template>
  <BaseDialog
    v-model="openTiaRecommendationDialog"
    :actionAllow="true"
    :btnEnable="true"
    fullscreen
    height="100vh"
    title="Tia Recommendation"
    cardTextClass="pa-0 ma-0"
  >
    <template #information>
      <v-row class="ma-0 px-5 pt-7">
        <v-col cols="6" class="pr-10" style="border-right: 1px dashed grey">
          <span class="text-subtitle-1 black--text font-weight-bold"
            >Manually Created Trip</span
          >
        </v-col>
        <v-col cols="6" class="pl-10">
          <span class="text-subtitle-1 black--text font-weight-bold"
            >Tia Recommendation Trip</span
          >
        </v-col>
      </v-row>
      <v-row class="ma-0 px-5">
        <v-col cols="6" class="pr-10" style="border-right: 1px dashed grey">
        </v-col>
        <v-col cols="6" class="pl-10">
          <v-row no-gutters class="tripObject-expansion-body">
            <v-col cols="12">
              <v-card elevation="0">
                <v-card-title class="pa-0">
                  <h6>{{ fleetModule.driver }}</h6>
                </v-card-title>
                <v-card-text class="pa-0">
                  <v-row v-if="tiaRecommendation.recommended_driver_details">
                    <v-col cols="6">
                      <span>Name :- </span>
                      <span class="font-weight-bold">{{
                        tiaRecommendation.recommended_driver_details.full_name
                      }}</span>
                    </v-col>
                    <v-col cols="6">
                      <span>Shift Time :- </span>
                      <span class="font-weight-bold">{{
                        tiaRecommendation.recommended_driver_details
                          .driver_shift_timing
                      }}</span>
                    </v-col>
                    <v-col cols="12" class="pt-0">
                      <v-divider></v-divider>
                    </v-col>
                  </v-row>
                  <v-row v-else>
                    <v-col cols="12">
                      <SelectField
                        id="driver"
                        :itemsList="driverList"
                        :label="`Select ${fleetModule.driver}`"
                        name="driver"
                        itemText="full_name"
                        itemValue="id"
                        v-model="assetData.driver"
                        :errorMessages="formErrors.driver"
                        @change="delete formErrors.driver"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12">
              <v-card elevation="0">
                <v-card-title class="pa-0">
                  <h6>{{ fleetModule.vehicle }}</h6>
                </v-card-title>
                <v-card-text class="pa-0">
                  <v-row v-if="tiaRecommendation.recommended_vehicle_details">
                    <v-col cols="6">
                      <span>{{ fleetModule.vehicle }} Number :-</span>
                      <span class="font-weight-bold">
                        {{
                          tiaRecommendation.recommended_vehicle_details
                            .vehicle_number
                        }}
                      </span>
                    </v-col>
                    <v-col cols="6">
                      <span>{{ fleetModule.vehicle }} Utilization :-</span>
                      <span class="font-weight-bold">
                        {{
                          tiaRecommendation.recommended_vehicle_utilization_percentage
                        }}
                        %
                      </span>
                    </v-col>
                  </v-row>
                  <v-row v-else>
                    <v-col cols="12">
                      <SelectField
                        id="vehicle"
                        :itemsList="vehicleList"
                        v-model="assetData.vehicle"
                        name="vehicle"
                        itemText="vehicle_number"
                        itemValue="id"
                        :label="`Select ${fleetModule.vehicle}`"
                        :errorMessages="formErrors.vehicle"
                        @change="delete formErrors.vehicle"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="ma-0 px-5">
        <v-col cols="6" style="border-right: 1px dashed grey" class="pr-10">
          <GoogleMap
            :hasMapInfo="false"
            mapId="TiaOldRecommendation"
            mapHeight="30vh"
            style="width: 100%"
            ref="tripTiaOldMapNew"
          />
        </v-col>
        <v-col cols="6" class="pl-10">
          <GoogleMap
            :hasMapInfo="false"
            mapId="TiaNewRecommendation"
            mapHeight="30vh"
            style="width: 100%"
            ref="tripTiaNewMapNew"
          />
        </v-col>
      </v-row>
      <v-row class="b ma-0 px-5">
        <v-col
          cols="6"
          style="border-right: 1px dashed grey"
          class="pr-10 pt-12"
        >
          <v-data-table
            :headers="tableHeaders"
            :items="planOrders"
            :items-per-page="-1"
            disable-pagination
            dense
            fixed-header
            hide-default-footer
            :hide-no-data="true"
            class="elevation-1 tia-recommendation-table"
            density="compact"
          >
          </v-data-table>
        </v-col>
        <v-col cols="6" class="pl-10 pt-12">
          <v-data-table
            :headers="tableHeaders"
            :items="sortedOrders"
            :items-per-page="-1"
            disable-pagination
            fixed-header
            dense
            hide-default-footer
            class="elevation-1 tia-recommendation-table"
            density="compact"
          >
          </v-data-table>
        </v-col>
      </v-row>
    </template>
    <template #action>
      <SecondaryButton
        name="Retry"
        btnClass="mr-2 rounded"
        icon=""
        iconClass=""
        @click="retryTiaRecommendationUnAllocatedTrip"
      >
      </SecondaryButton>
      <PrimaryButton
        name="Accept"
        btnClass="mr-2 rounded"
        icon=""
        iconClass=""
        @click="acceptTiaRecommendationUnAllocatedTrip"
      >
      </PrimaryButton>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/BaseDialog.vue";
import { bus } from "@/main";
import GoogleMap from "@/components/BaseComponents/GoogleMap.vue";
import Tooltip from "@/components/BaseComponents/Tooltip.vue";
import { fleetModule, tripModule } from "@/utils/moduleMapping";

export default {
  components: {
    BaseDialog,
    GoogleMap,
    Tooltip,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    tripObj: {
      default: null,
    },
  },
  data() {
    return {
      fleetModule,
      tiaRecommendation: {},
      orderHeaders: [
        {
          text: "Order Reference Number",
          value: "reference_number",
          sortable: false,
        },
        { text: "Customer Name", value: "customer_name", sortable: false },
        { text: "Customer Code", value: "customer_code", sortable: false },
        { text: "Location ID", value: "location_id", sortable: false },
        { text: "Contact Number", value: "contact_number", sortable: false },
        { text: "Order Type", value: "order_type", sortable: false },
        { text: "Address", value: "address", sortable: false },
        {
          text: "Time Window",
          value: "customer_availability_window",
          sortable: false,
        },
        {
          text: "Planned Processing time",
          value: "planned_processing_time",
          sortable: false,
        },
        {
          text: "Total Items",
          value: "total_items",
          sortable: false,
        },
        {
          text: "Volume (CBM)",
          value: "volume",
          sortable: false,
        },
        {
          text: "Weight (Kg)",
          value: "weight",
          sortable: false,
        },
        // {
        //   text: "Arrival Time",
        //   value: "timings",
        //   sortable: false,
        // },
        // {
        //   text: "Departure Time",
        //   value: "timings",
        //   sortable: false,
        // },
      ],
      planOrders: [],
      sortedOrders: [],

      assetData: {},

      driverList: [],
      vehicleList: [],

      formErrors: {},
    };
  },
  watch: {
    value(val) {
      if (val && this.tripObj) {
        this.getTiaRecommendation(this.tripObj.id);
      }
    },
  },
  computed: {
    openTiaRecommendationDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    tableHeaders() {
      return [...this.orderHeaders];
    },
  },
  methods: {
    async retryTiaRecommendationUnAllocatedTrip() {
      bus.$emit("showLoader", true);
      await this.$api.trip
        .retryTiaRecommendationUnAllocatedTrip(this.tripObj.id)
        .then(async () => {
          bus.$emit("showLoader", false);
          await this.getTiaRecommendation(this.tripObj.id);
        })
        .catch((err) => {
          bus.$emit("showLoader", false);
          console.log(err);
        });
    },
    acceptTiaRecommendationUnAllocatedTrip() {
      bus.$emit("showLoader", true);
      this.$api.trip
        .acceptTiaRecommendationUnAllocatedTrip(this.tripObj.id, {
          ...this.assetData,
        })
        .then(() => {
          this.openTiaRecommendationDialog = false;
          bus.$emit("showToastMessage", {
            message: `Recommendation accepted for trip ${this.tripObj.reference_number}!`,
            color: "success",
          });
          this.$emit("refreshList");
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    getDriverSelectList(params = {}) {
      params = {
        ...params,
        limit: "all",
      };
      bus.$emit("showLoader", true);
      this.$api.driver
        .getDriverSelectList(params)
        .then((res) => {
          this.driverList = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getVehicleSelectList(params = {}) {
      params = {
        ...params,
        limit: "all",
      };
      bus.$emit("showLoader", true);
      this.$api.vehicle
        .getVehicleSelectList(params)
        .then((res) => {
          this.vehicleList = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getTiaRecommendation(id) {
      bus.$emit("showLoader", true);
      this.$api.trip
        .getTiaRecommendationUnAllocatedTrip(id)
        .then((res) => {
          this.tiaRecommendation = res.data;
          if (res.data.recommended_driver_details) {
            this.assetData.driver = res.data.recommended_driver_details.id;
          } else {
            this.getDriverSelectList();
          }
          if (res.data.recommended_vehicle_details) {
            this.assetData.vehicle = res.data.recommended_vehicle_details.id;
          } else {
            this.getVehicleSelectList();
          }
          this.sortedOrders = [...res.data.recommended_orders];
          this.planOrders = [...res.data.orders];

          let timer = setTimeout(() => {
            if (this.$refs.tripTiaOldMapNew) {
              this.$refs.tripTiaOldMapNew.clearGeoJson();
              this.$refs.tripTiaOldMapNew.clearMarker();
              clearInterval(timer);
              this.$refs.tripTiaOldMapNew.setPlannedRoute(
                res.data.planned_route
              );
            }
          }, 100);

          let newTimer = setTimeout(() => {
            if (this.$refs.tripTiaNewMapNew) {
              this.$refs.tripTiaNewMapNew.clearGeoJson();
              this.$refs.tripTiaNewMapNew.clearMarker();
              clearInterval(newTimer);
              this.$refs.tripTiaNewMapNew.setPlannedRoute(
                res.data.recommended_route
              );
            }
          }, 100);
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
  },
};
</script>
